<template>
    <div class="trip-detail" v-loading="loading">
        <div class="flex-between">
            <h3 class="title">行程信息</h3>
            <el-button @click="refresh">刷新</el-button>
        </div>
        <el-descriptions :column="3" border>
            <el-descriptions-item label="行程编号">
                {{ detail.orderDriverNo }}
                <el-button type="text" class="ml-5" @click="$utils.copyText(detail.orderDriverNo)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="状态">
                <el-tag v-for="item in $const.TRAVELTRIPSTATUS.filter(item => item.value === detail.status)" :key="item.value" :type="item.type">{{ item.label }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="机构名称">
                {{ organizationName || '-' }}
            </el-descriptions-item>
            <el-descriptions-item label="线路名称">
                {{ detail.travelLineName }}
            </el-descriptions-item>
            <el-descriptions-item label="行程费用">
                <span class="util-money">￥{{ detail.fee }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="车辆余座">
                <span>乘客{{ detail.passengerNum }} . 余座{{ detail.vehicleSeat - 1 - detail.passengerNum }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="车辆号牌" style="justify-content: center">
                <span v-if="detail.licenseNo" :style="getPlateStyle(detail.licenseNo)">{{ formatPlateNumber(detail.licenseNo) }}</span>
                <span v-else>-</span>
                <el-button v-if="detail.licenseNo" type="text" @click="$utils.copyText(detail.licenseNo)">复制</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="车辆型号">
                {{ detail.vehicleModel }}<el-button type="text" class="ml-5" @click="$utils.largeImgFn(detail.vehiclePhoto)">查看</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="用车时间">
                {{ detail.orderTime | filterTime }}
            </el-descriptions-item>
            <el-descriptions-item label="值班司机">
                {{ detail.driverName }}
            </el-descriptions-item>
            <el-descriptions-item label="联系电话">
                {{ detail.driverPhone }}
                <el-button type="text" class="ml-5" @click="$utils.copyText(detail.driverPhone)">复制</el-button>
            </el-descriptions-item>lterTime }}
            <el-descriptions-item label="完成/取消时间">
                {{ detail.finishTime | filterTime }}
            </el-descriptions-item>
        </el-descriptions>
        <el-tabs v-model="activeName">
            <el-tab-pane label="订单信息" name="info">
                <el-table :data="detail.orders" border height="calc(100vh - 510px)">
                    <el-table-column prop="orderNo" label="订单编号" width="200">
                        <template slot-scope="scope">
                            {{scope.row.orderNo}}
                            <el-button type="text" class="ml-5" @click="$utils.copyText(scope.row.orderNo)">复制</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" width="70">
                        <template slot-scope="scope">
                            <el-tag v-for="item in $const.TRAVELALLORDERSTATUS.filter(item => item.value === scope.row.status)" :key="item.value" :type="item.type">{{ item.label }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="contactPhone" label="联系电话" width="130">
                        <template slot-scope="scope">
                            {{scope.row.contactPhone}}
                            <el-button type="text" class="ml-5" @click="$utils.copyText(scope.row.contactPhone)">复制</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="passengerNum" label="人数" width="60" />
                    <el-table-column prop="orderTime" label="用车时间" width="120" >
                        <template slot-scope="scope">
                            {{scope.row.orderTime | filterTime}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="startPointName" label="出发地" />
                    <el-table-column show-overflow-tooltip prop="endPointName" label="目的地" />
                    <el-table-column prop="trafficNo" label="航班号/班次号" width="130">
                        <template slot-scope="scope">
                            <span v-if="scope.row.trafficType && scope.row.trafficNo">{{scope.row.trafficNo}} ( {{ scope.row.trafficType }} )</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" label="备注" />
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="操作历史" name="history">
                <el-table :data="detail.logs" border height="calc(100vh - 510px)">
                    <el-table-column prop="remark" label="记录内容" />
                    <el-table-column prop="operator" label="操作人" width="140" />
                    <el-table-column prop="created" label="记录时间" width="180">
                        <template slot-scope="scope">
                            {{scope.row.created | filterTime}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
export default {
    name: 'tripDetail',
    data() {
        return {
            detail: {},
            id: this.$route.query.id,
            organizationName: '',
            activeName: "info",
            loading: false
        }
    },
    created() {
        this.getDetail()
    },
    methods: {
        async getDetail() {
            this.loading = true;
            let url ="/api/v1/manage/travelOrder/order/driver/detail"
            const { code, data } = await this.$axios.get(url, {
                id: this.id
            });
            if(code == 1) {
                this.detail = data;
                this.organizationName = await this.getOrgName(data.organizationId)
            }
            this.loading = false;
        },
        refresh() {
            this.getDetail();
        }
    }
}
</script>

<style lang="less" scoped>
.trip-detail {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    .flex-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }

    .title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        margin: 0;
        padding-left: 10px;
        border-left: 3px solid #2B77FF;
    }

    // 价格样式
    .util-money {
        font-weight: 600;
        color: #F56C6C;
    }

    .ml-5 {
        margin-left: 5px;
    }

    // 描述列表样式
    :deep(.el-descriptions) {
        border-radius: 8px;
        overflow: hidden;
    }

    :deep(.el-descriptions-item__label) {
        width: 90px;
        font-weight: 500;
        color: #606266;
        background: #f5f7fa;
    }

    :deep(.el-descriptions-item__content) {
        min-width: 150px;
        color: #303133;
        
        .el-button--text {
            color: #2B77FF;
            
            &:hover {
                color: #1a5fd9;
            }
        }
    }

    // Tab样式
    :deep(.el-tabs) {
        margin-top: 20px;
        
        .el-tabs__item {
            font-size: 14px;
            
            &.is-active {
                font-weight: 500;
                color: #2B77FF;
            }
        }
        
        .el-tabs__active-bar {
            background-color: #2B77FF;
        }
    }

    // 表格样式
    :deep(.el-table) {
        border-radius: 8px;
        
        th {
            background: #f5f7fa !important;
            font-weight: 500;
        }
        
        .el-button--text {
            color: #2B77FF;
            
            &:hover {
                color: #1a5fd9;
            }
        }
    }

    // 刷新按钮
    .el-button {
        border-radius: 6px;
    }
}
</style>